import React, { SVGProps } from 'react';

export const WarningIcon: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 17,
  height = 15,
  ...props
}) => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 17 15"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.3139 10.8287L10.5068 1.19823C10.272 0.830888 9.94846 0.528578 9.56606 0.319171C9.18367 0.109764 8.75471 0 8.31873 0C7.88275 0 7.45379 0.109764 7.0714 0.319171C6.689 0.528578 6.36548 0.830888 6.13067 1.19823L0.323595 10.8287C0.118457 11.1707 0.00696065 11.5606 0.000315475 11.9593C-0.0063297 12.358 0.0921105 12.7515 0.285739 13.1001C0.509602 13.4925 0.833632 13.8184 1.22471 14.0445C1.6158 14.2706 2.05991 14.3889 2.51166 14.3872H14.1258C14.5746 14.392 15.0167 14.2783 15.4075 14.0576C15.7983 13.837 16.124 13.5171 16.3517 13.1304C16.551 12.7781 16.6526 12.3791 16.646 11.9744C16.6393 11.5697 16.5247 11.1742 16.3139 10.8287ZM8.31873 11.3587C8.16899 11.3587 8.02261 11.3143 7.8981 11.2311C7.77359 11.1479 7.67655 11.0297 7.61925 10.8913C7.56194 10.753 7.54695 10.6008 7.57616 10.4539C7.60538 10.307 7.67748 10.1721 7.78337 10.0662C7.88925 9.96035 8.02416 9.88824 8.17102 9.85903C8.31789 9.82982 8.47012 9.84481 8.60847 9.90211C8.74681 9.95942 8.86506 10.0565 8.94825 10.181C9.03144 10.3055 9.07584 10.4519 9.07584 10.6016C9.07584 10.8024 8.99608 10.995 8.85409 11.137C8.7121 11.2789 8.51953 11.3587 8.31873 11.3587ZM9.07584 8.33025C9.07584 8.53105 8.99608 8.72363 8.85409 8.86561C8.7121 9.0076 8.51953 9.08737 8.31873 9.08737C8.11793 9.08737 7.92536 9.0076 7.78337 8.86561C7.64138 8.72363 7.56161 8.53105 7.56161 8.33025V5.30179C7.56161 5.10099 7.64138 4.90842 7.78337 4.76643C7.92536 4.62444 8.11793 4.54468 8.31873 4.54468C8.51953 4.54468 8.7121 4.62444 8.85409 4.76643C8.99608 4.90842 9.07584 5.10099 9.07584 5.30179V8.33025Z"
        fill="#C33838"
      />
    </svg>
  );
};
